import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import IdentityDocumentUpload from "pages/identity-document-upload";
import SubmissionSuccessConfirmation from "pages/submission-success-confirmation";
import ContactInformationForm from "pages/contact-information-form";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<ContactInformationForm />} />
        <Route path="/document" element={<IdentityDocumentUpload />} />
        <Route path="/submission" element={<SubmissionSuccessConfirmation />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;